import { useState } from "react";
import HBLoading from "../../HBLoading";

export default function Loading({ height = 200 }) {
  const [id] = useState(Date.now());
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: `${height}px`,
      }}
    >
      <HBLoading size={"30px"} id={id} />
    </div>
  );
}
